import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
    createSelector,
} from '@reduxjs/toolkit'
import * as API from '../utils/api'
import axios from '../utils/axios'

const regionsAdapter = createEntityAdapter({
    // sortComparer: (a, b) => b.region_code.localeCompare(a.region_code),
    sortComparer: (a, b) => b.region_code.localeCompare(a.region_code),
})

const initalState = regionsAdapter.getInitialState({
    status: 'idle',
    error: null,
    actives: []
})

// Fetch API for building list and singular building
export const fetchRegions = createAsyncThunk(
    'regions/fetchRegions', 
    async () => {
        return await axios.get(API.REGIONS_API)
                        .then(response => response.data)
    }
)


const regionsSlice = createSlice({
    name: 'regions',
    initialState: initalState,
    reducers: {
        changeRegions(state, {payload: regions}) {
            state.actives = regions
        }
    },
    extraReducers: {
        [fetchRegions.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchRegions.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            regionsAdapter.upsertMany(state, action.payload)
            state.actives = action.payload.map(item => item.id)
        },
        [fetchRegions.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        }
    }
})

export default regionsSlice.reducer

export const {changeRegions} = regionsSlice.actions;

export const {
    selectAll: selectAllRegions,
} = regionsAdapter.getSelectors((state) => state.regions)

const selectRegionsActives = state => state.regions.actives

export const selectActiveRegions = createSelector(
    [
        (state) => selectAllRegions(state),
        (state) => selectRegionsActives(state)
    ],
    (regions, regionsActive) => 
        regions
            .filter(region => regionsActive.some(region_id => region_id == region.id))
)